import { Routes } from '@angular/router';

import { AssignuserdashboardComponent } from 'app/assignuserdashboard/assignuserdashboard.component';
import { ChatAiComponent } from 'app/ChatAi/ChatAi/ChatAi.component';

export const AssignUserLayoutRoutes: Routes = [
  { path: 'assignuserdashboard', component: AssignuserdashboardComponent },
  { path: 'dr-mo-ai-assign', component: ChatAiComponent },
  
  // { path: 'analysis', component: AnalysisComponent },
  // { path: 'reports', component: ReportsComponent },
  // { path: 'downloads', component: DownloadsComponent },
  // { path: 'actionplan', component: ActionPlanComponent },
  // { path: 'addassignuser', component: AddAssignUserComponent }

];
